export default __webpack_public_path__ + "static/media/sleeping_bag_light.afcd5d46.png";